/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2021-01-04 14:09:17
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\app.js
 * @Description: app渠道主体js
 */
'use strict';
angular
    .module('editingCenterAppModule', [
        'editingCenterAppLeftModule',
        'editingCenterAppRouterModule',
        'editingCenterCompiledModule',
        'editingCenterPendingModule',
        'editingCenterSignedModule',
        'util.trsTimeline',
        'versionModule',
        'editingCenterObjTimeModule',
        'editingCenterAppServiceModule',
        'initAddMetaDataModule',
        'appPreviewRouterModule',
        'appExternalSystemModule',
        'appQuickSignModule',
        'appDirectiveModule',
        'editingCenterAppFocusModule', // 新增客户端渠道焦点图管理
    ])
    .controller('EditingCenterAppController', [function() {}])
    .value('appConst', {
        params: {
            listenStroageKey: 'App',
            // 各类操作请求方法
            serviceid: 'mlf_appoper', // 服务ID
            trial: 'trialMetaDatas', // 送审方法
            trialParams: {
                serviceid: 'mlf_appoper',
                methodname: 'trialMetaDatas',
            },
            rejectionParams: {
                serviceid: 'mlf_appoper',
                methodname: 'rejectionMetaDatas',
            },
            delete: {
                serviceid: 'mlf_appoper',
                methodname: 'trashMetaDatas',
            },
            daibianSign: {
                serviceid: 'mlf_appoper',
                methodname: 'appDaiBianPublish'
            },
            daibianTimeSign: {
                serviceid: 'mlf_appoper',
                methodname: 'appDaiBianTimingPublish'
            },
            daishenSign: {
                serviceid: 'mlf_appoper',
                methodname: 'appDaiShenPublish',
            },
            daishenTimeSign: {
                serviceid: 'mlf_appoper',
                methodname: 'appDaiShenTimingPublish'
            },
            changeTimeSign: {
                serviceid: 'mlf_appoper',
                methodname: 'appChangeTimingPublish'
            }, // 定时签发中的修改定时签发
            sign: {
                0: 'appDaiBianPublish',
                1: 'appDaiShenPublish',
                2: 'appYiQianFaPublish',
            }, // 签发方法
            rejection: 'rejectionMetaDatas', // 撤稿方法
            timeSign: {
                0: 'appDaiBianTimingPublish',
                1: 'appDaiShenTimingPublish',
            }, // 定时签发方法
            publish: {
                0: 'appDaiBianPublish',
                1: 'appDaiShenPublish',
                2: 'appYiQianFaPublish',
            }, // 发布方法
            draftListDB: {
                // 待编发稿单参数
                serviceid: 'mlf_appfgd',
                methodname: 'appDaiBianbatchUpdateFgdUsers',
            },
            draftListDS: {
                // 待审发稿单参数
                serviceid: 'mlf_appfgd',
                methodname: 'appDaiShenbatchUpdateFgdUsers',
            },
            draftListQuery: {
                // 发稿单查询参数
                serviceid: 'mlf_appfgd',
                methodname: 'queryFgdByMetaDataId',
            },
            retraction: {
                serviceid: 'mlf_appoper',
                methodname: 'withdraw',
            },
            propagandaReview: {
                serviceid: 'mlf_appoper',
                methodname: 'trialByPropagandaDepartment',
            },
            collect: {
                serviceid: 'mlf_appoper',
                methodname: 'collectionMetaDatas',
            }

        },
        list: {
            FGD_EDITINFO: [], // 发稿单编辑信息
            FGD_AUTHINFO: [{ isCreate: true }], // 发稿单作者信息
            ISNOPAYMENT: '1', // 是否发稿费，默认不发稿费
            COMMENTSET: '1', // 评论设置参数,默认是先审后发
            THUMB: '1', // 点赞设置，默认打开
            LISTSTYLE: 0, // 列表样式。默认图文
            LISTTITLE: '', // 列表标题，默认空
            ISFOCUSIMAGE: 1, // 是否焦点图。默认不是
            LISTPICS: [], // 列表图集
            TITLE: '',
            ORIGINAL: 0, // 原创稿件
            SPECIALDOC: 0, // 特殊稿件
            METADATAID: '0', // 稿件id
            CHNLDOCID: '0', // 渠道id
            FOCUSIMGTITLE: '', // 焦点标题
            FOCUSIMAGEDESC: '', // 焦点图描述
            FOCUSIMAGE: [], // 焦点图
            URL: '', // 广告url
            ORIGINALTYPE: '',
            KEYWORDS: [], // 关键词,
            serviceid: 'mlf_appmetadata', // 执行保存操作时的方法
            SIGNATUREAUTHOR: '', // 署名作者
            NEWSSOURCES: '', // 稿件来源
        },
    });
